import React, { useState, useEffect } from 'react';
import {
    Container, Typography, Box, Paper, Divider, TextField, Button, Stack,
    Grid, Switch, FormControlLabel, IconButton, InputAdornment, Tooltip
} from '@mui/material';
import { Visibility, VisibilityOff, InfoOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useAppStore } from '../../../../../store/appStore.tsx';
import { useValue } from '../../../../../context/ContextProvider';
import { updateConfigAlarma } from '../../../../../actions/alarmaActions';

// --- Lógica de negocio y hooks (asumimos que están disponibles) ---
//const useAppStore = (selector) => ({ currentUser: { token: 'dummy' }, device: { devId: 'dummy' }, startLoading: () => {}, endLoading: () => {} });
//const useValue = () => ({ dispatch: () => {} });
//const updateConfigAlarma = async (currentUser, devId, command, payload, dispatch) => {
//    //console.log("Simulando envío de:", { command, payload });
//    await new Promise(resolve => setTimeout(resolve, 500));
//    return { resp: 0, insertId: Math.floor(Math.random() * 1000) };
//};

// --- Generador del estado inicial ---
export const generarEstadoInicialWifi = () => ({
    hab: 1,
    ssid: "ssid",
    ssidPass: "123456",
    apPass: "cerberus",
});

function ConfiguracionWifiForm({
    config, setConfig,
    state, setState,
    originalConfigRef,
}) {
    const { jsonOutput, formDirty, jsonNeedsUpdate, configId, estado, color } = state;
    const theme = useTheme();
    const { currentUser, device, startLoading, endLoading } = useAppStore();
    const { dispatch } = useValue();

    // Estados locales para la UI del formulario
    const [showSsidPass, setShowSsidPass] = useState(false);
    const [confirmSsidPass, setConfirmSsidPass] = useState(config.ssidPass);
    const [showApPass, setShowApPass] = useState(false);
    const [confirmApPass, setConfirmApPass] = useState(config.apPass);
    
    // --- CORRECCIÓN: Se elimina el useEffect que causaba el error ---
    
    // Lógica para el estado de la UI que se reporta al padre
    useEffect(() => {
        const originalConfigString = JSON.stringify(originalConfigRef.current);
        const currentConfigString = JSON.stringify(config);
        const isDirty = currentConfigString !== originalConfigString;

        let needsUpdate = true;
        try {
            const jsonObject = JSON.parse(jsonOutput || '{}');
            needsUpdate = JSON.stringify(jsonObject) !== currentConfigString;
        } catch (e) { needsUpdate = true; }

        if (isDirty !== formDirty || needsUpdate !== jsonNeedsUpdate) {
            setState(prev => ({ ...prev, formDirty: isDirty, jsonNeedsUpdate: needsUpdate }));
        }
    }, [config, jsonOutput, formDirty, jsonNeedsUpdate, originalConfigRef, setState]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        const valorFinal = type === 'checkbox' ? (checked ? 1 : 0) : value;
        setConfig(prev => ({ ...prev, [name]: valorFinal }));
    };

    const handleGenerateJson = () => {
        setState(prev => ({ ...prev, jsonOutput: JSON.stringify(config, null, 2), jsonNeedsUpdate: false }));
    };

    const sendConfig = async() => {
        if (config.ssidPass !== confirmSsidPass || config.apPass !== confirmApPass) {
            alert("Las contraseñas o sus confirmaciones no coinciden.");
            return;
        }
        
        startLoading();
        setState(prev => ({ ...prev, configId: "---", estado: "Esperando respuesta...", color: "black"}));
        const updateResult = await updateConfigAlarma(currentUser, device.devId, "CMD_SET_CONFIG_WIFI", config, dispatch);

        if (updateResult?.deviceResponse === 0) {
            originalConfigRef.current = JSON.parse(JSON.stringify(config));
            setState(prev => ({ ...prev, formDirty: false, configId: updateResult.insertId, estado: "Configuración actualizada con éxito.", color: "green"}));
        } else {
            setState(prev => ({ ...prev, configId: 0, estado: "Error. Configuración NO actualizada.", color: "red"}));
        }
        endLoading();
    };

    // --- CORRECCIÓN: La lógica de restauración de los campos de confirmación vive aquí ---
    const handleCancel = () => {
        if (window.confirm("¿Seguro que quieres descartar los cambios?")) {
            const originalConfig = originalConfigRef.current;
            setConfig(originalConfig);
            // Sincronizamos los campos de confirmación con los valores originales
            setConfirmSsidPass(originalConfig.ssidPass);
            setConfirmApPass(originalConfig.apPass);
        }
    };

    const ssidPassError = config.ssidPass !== confirmSsidPass;
    const apPassError = config.apPass !== confirmApPass;

    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h5" component="h1" gutterBottom>Configuración WiFi</Typography>
                <Divider sx={{ mb: 2 }} />
                <Box component="form" onSubmit={(e) => { e.preventDefault(); sendConfig(); }}>
                    <Grid container spacing={4}>
                        {/* Columna izquierda: Formulario */}
                        <Grid item xs={12} md={6}>
                            <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}><FormControlLabel control={<Switch name="hab" checked={!!config.hab} onChange={handleChange} />} label="Habilitar WiFi" /></Grid>
                                    <Grid item xs={12}><TextField fullWidth name="ssid" label="SSID" value={config.ssid} onChange={handleChange} InputProps={{ endAdornment: (<Tooltip title="Para modo cliente"><InfoOutlined sx={{ color: 'action.active' }} /></Tooltip>) }}/></Grid>
                                    <Grid item xs={12}><TextField fullWidth name="ssidPass" label="Contraseña SSID" type={showSsidPass ? 'text' : 'password'} value={config.ssidPass} onChange={handleChange} 
                                        inputProps={{ autoComplete: 'new-password' }}
                                        InputProps={{ endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Para modo cliente"><InfoOutlined sx={{ color: 'action.active', mr: 1 }} /></Tooltip>
                                                <IconButton onClick={() => setShowSsidPass(!showSsidPass)} edge="end">{showSsidPass ? <VisibilityOff /> : <Visibility />}</IconButton>
                                            </InputAdornment>
                                        )}}
                                    /></Grid>
                                    <Grid item xs={12}><TextField fullWidth name="confirmSsidPass" label="Confirmar Contraseña SSID" type={showSsidPass ? 'text' : 'password'} value={confirmSsidPass} onChange={(e) => setConfirmSsidPass(e.target.value)} 
                                        error={ssidPassError} 
                                        helperText={ssidPassError ? "Las contraseñas no coinciden" : ""}
                                        inputProps={{ autoComplete: 'new-password' }}
                                    /></Grid>
                                    <Grid item xs={12}><TextField fullWidth name="apPass" label="Contraseña Access Point" type={showApPass ? 'text' : 'password'} value={config.apPass} onChange={handleChange} 
                                        inputProps={{ autoComplete: 'new-password' }}
                                        InputProps={{ endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Para modo Access Point Server"><InfoOutlined sx={{ color: 'action.active', mr: 1 }} /></Tooltip>
                                                <IconButton onClick={() => setShowApPass(!showApPass)} edge="end">{showApPass ? <VisibilityOff /> : <Visibility />}</IconButton>
                                            </InputAdornment>
                                        )}}
                                    /></Grid>
                                    <Grid item xs={12}><TextField fullWidth name="confirmApPass" label="Confirmar Contraseña AP" type={showApPass ? 'text' : 'password'} value={confirmApPass} onChange={(e) => setConfirmApPass(e.target.value)} 
                                        error={apPassError} 
                                        helperText={apPassError ? "Las contraseñas no coinciden" : ""}
                                        inputProps={{ autoComplete: 'new-password' }}
                                    /></Grid>
                                </Grid>
                            </Paper>
                        </Grid>

                        {/* Columna derecha: JSON y Resumen */}
                        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Paper variant="outlined" sx={{ p: 2, flexGrow: 1, display: 'flex', flexDirection: 'column', position: 'relative', pt: 4 }}>
                                <Typography variant="caption" component="div" sx={{ position: 'absolute', top: 0, left: 12, transform: 'translateY(-50%)', bgcolor: 'background.paper', px: 1, color: 'primary.main', fontWeight: 'bold' }}>JSON DE CONFIGURACIÓN</Typography>
                                <Box sx={{ flexGrow: 1, overflowY: 'auto', border: `1px solid ${jsonNeedsUpdate ? theme.palette.warning.main : theme.palette.divider}`, borderRadius: 1, p: 1.5, backgroundColor: jsonNeedsUpdate ? '#ffe0b2' : 'background.paper', minHeight: '200px' }}>
                                    <Typography component="pre" sx={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', m: 0, fontSize: '0.875rem' }}>{jsonOutput}</Typography>
                                </Box>
                                <Button fullWidth variant="contained" color={jsonNeedsUpdate ? "warning" : "primary"} onClick={handleGenerateJson} sx={{ mt: 1 }}>{jsonNeedsUpdate ? "Actualizar JSON" : "Generar JSON"}</Button>
                            </Paper>
                            <Paper variant="outlined" sx={{ p: 2, position: 'relative', pt: 4 }}>
                                <Typography variant="caption" component="div" sx={{ position: 'absolute', top: 0, left: 12, transform: 'translateY(-50%)', bgcolor: 'background.paper', px: 1, color: 'primary.main', fontWeight: 'bold' }}>RESUMEN</Typography>
                                <Typography variant="body2">**Habilitado:** {config.hab ? 'Sí' : 'No'}</Typography>
                                <Typography variant="body2">**SSID:** {config.ssid}</Typography>
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="body2" color={formDirty ? 'error' : 'inherit'}>**Modificado:** {formDirty ? 'Sí' : 'No'}</Typography>
                                    <Typography variant="body2" color={jsonNeedsUpdate ? 'warning.main' : 'inherit'}>**JSON Actualizado:** {jsonNeedsUpdate ? 'No' : 'Sí'}</Typography>
                                </Box>
                                <Divider sx={{ my: 1 }}/>
                                <Typography variant="body2" sx={{color: color}}><strong>ID:</strong> {configId} - <strong>Estado:</strong> {estado}</Typography>
                            </Paper>
                        </Grid>
                        
                        <Grid item xs={12}>
                            <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                                <Button variant="outlined" color="secondary" onClick={handleCancel} disabled={!formDirty}>Cancelar</Button>
                                <Button type="submit" variant="contained" disabled={jsonNeedsUpdate || ssidPassError || apPassError}>Enviar</Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Container>
    );
}

export default ConfiguracionWifiForm;